import { useState, useEffect } from "react";
import { Link } from "wouter";
import Logo from "../Logo";
import { cn } from "@/lib/utils";

import AuthHeader from "@/components/AuthHeader";

type NavItem = {
  name: string;
  href: string;
};

const navItems: NavItem[] = [
 // { name: "Services", href: "#services" },
 // { name: "Reels", href: "#reels" },
  //{ name: "Success Stories", href: "#case-studies" },
//  { name: "Contact", href: "#contact" },
];

export default function Header({user, setUser, setUserCredits, isLoadingAuth, setIsLoadingAuth}: {}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState<string>("");
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scrolling and section detection
  useEffect(() => {
    const handleScroll = () => {
      // Update header background on scroll
      setIsScrolled(window.scrollY > 10);
      
      // Detect current section
      const sections = document.querySelectorAll("section[id]");
      let current = "";

      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top;
        if (sectionTop < 150) {
          current = section.getAttribute("id") || "";
        }
      });

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
      isScrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
    )}>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link href="/" className="flex items-center z-10">
          <Logo className={cn("h-9 transition-all", isScrolled ? "h-8" : "h-9")} />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className={cn(
                "relative text-gray-800 hover:text-purple-600 font-medium transition-colors",
                "after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-0.5 after:bg-green-500",
                "after:transition-all after:duration-300 hover:after:w-full",
                activeSection === item.href.substring(1) ? "text-purple-600 after:w-full" : ""
              )}
            >
              {item.name}
            </a>
          ))}
          
          <AuthHeader 
            user={user} 
            setUser={setUser} 
            setUserCredits={setUserCredits} 
            setIsLoadingAuth={setIsLoadingAuth} 
          />
        </nav>
        
        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-purple-600 focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={mobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>
      
      {/* Mobile Menu */}
      <div className={cn("md:hidden transition-all duration-300 overflow-hidden", 
        mobileMenuOpen ? "max-h-80" : "max-h-0"
      )}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white shadow-md">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className={cn(
                "block px-3 py-2 text-base font-medium rounded-lg transition-colors",
                activeSection === item.href.substring(1) 
                  ? "bg-purple-50 text-purple-600" 
                  : "text-gray-900 hover:bg-gray-50 hover:text-purple-600"
              )}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
          
          <div className="px-3 pt-3 pb-1">
            <a
              href="#contact"
              className="w-full block py-2 text-center ring-1 ring-purple-600 text-purple-700 font-medium rounded-lg hover:bg-purple-100 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get Free Analysis
            </a>
          </div>

          <div className="p-4 flex justify-end">
            <AuthHeader user={user} setUserCredits={setUserCredits} setUser={setUser} setIsLoadingAuth={setIsLoadingAuth} />
          </div>
        </div>
      </div>
    </header>
  );
}
